import TitledContent from "../TitledContent/TitledContent";
import { ModalRoot } from "./Modal.styles";
import { ModalProps } from "./Modal.types";

const Modal = ({ title, children, elevation = 0, closable = true, ...rest }: ModalProps): JSX.Element => {
    return (
        <ModalRoot elevation={elevation} closable={closable} {...rest}>
            <TitledContent title={title} body={children} />
        </ModalRoot>
    );
};

export default Modal;
